import { render, staticRenderFns } from "./PageReport.vue?vue&type=template&id=2c85aa74&scoped=true"
import script from "./PageReport.vue?vue&type=script&lang=ts"
export * from "./PageReport.vue?vue&type=script&lang=ts"
import style0 from "./PageReport.vue?vue&type=style&index=0&id=2c85aa74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85aa74",
  null
  
)

export default component.exports